import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { useFulfillmentPlannerContext } from '../../fulfillment-planner/context';
import { LabelPurchaseButton } from '../label-purchase-button';
import { CswPrimaryActionPropType } from '../../prop-types/csw-primary-action';

export const OtherLabelActionButton = ({ disabled = false, onAction, primaryAction, eventTriggerSource }) => {
  const { fulfillmentPlanId } = useFulfillmentPlannerContext();

  return (
    <LabelPurchaseButton fulfillmentPlanIds={[fulfillmentPlanId]} labelPurchaseCallback={onAction} trackingId={eventTriggerSource}>
      {({ onClick }) => (
        <DropdownMenuItem disabled={disabled} onClick={onClick}>
          <FormattedMessage {...primaryAction.translation} />
        </DropdownMenuItem>
      )}
    </LabelPurchaseButton>
  );
};

OtherLabelActionButton.propTypes = {
  eventTriggerSource: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  primaryAction: CswPrimaryActionPropType.isRequired,
  disabled: PropTypes.bool,
};
